import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, Subscription} from 'rxjs';
import {InternalMsgService} from './internal.msg.service';
import {AccountItem} from '../models/accountitem';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class APIService {
  msgSubscr: Subscription;
  loggedAccount: AccountItem = new AccountItem();

  constructor(private http: HttpClient,
              private msgService: InternalMsgService) {
    this.msgSubscr = this.msgService.loggedInAccountSet$.subscribe(
      account => {
        if (account) {
          this.loggedAccount = account;
        }
      });
  }

  private buildUrl(endpoint: string): string {
    const base = environment.apiBaseUrl.replace(/\/+$/, ''); // trim trailing slashes
    const ep = endpoint.replace(/^\/+/, ''); // trim leading slashes
    return `${base}/${ep}`;
  }

  httpOptions(): any {
    return {
      headers: new HttpHeaders({
          "Content-Type": 'application/json; charset=UTF-8',
          "accountkey": `${this.loggedAccount.accountKey}`,
          "email": this.loggedAccount.email,
          "empid": this.loggedAccount.empId,
          "azureaccountname": this.loggedAccount.email
        }
      )
    };
  }

  httpOptionsNoAccount(): any {
    return {
      headers: new HttpHeaders({
          'Content-Type': 'application/json; charset=UTF-8'
        }
      )
    };
  }

  getAPI(endpoint: string): Observable<any> {
    const url = this.buildUrl(endpoint);
    return this.http.get(url, this.httpOptions(),);
  }

  getAPINoAccount(endpoint: string): Observable<any> {
    const url = this.buildUrl(endpoint);
    return this.http.get(url, this.httpOptionsNoAccount());
  }

  postAPI(endpoint: string, payload: any): Observable<any> {
    const url = this.buildUrl(endpoint);
    return this.http.post(url, JSON.stringify(payload), this.httpOptions());
  }

  deleteByEnpointApi(endpoint: string): Observable<any> {
    const url = this.buildUrl(endpoint);
    return this.http.delete(url, this.httpOptions());
  }
}
